import * as React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { styles } from './styles';
import { Status } from 'models/task';

interface AdditionalRemarksProps {
  taskStatus: Status;
}
const AdditionalRemarks = ({ taskStatus }: AdditionalRemarksProps) => (
  <View
    style={{
      flexDirection: 'column',
      marginBottom: 20,
    }}
  >
    <Text style={styles.titleSmall}>Additional Remarks</Text>
    {taskStatus.status === 'complete' && taskStatus.remarks ? (
      <Text style={styles.textMedium}>{taskStatus.remarks}</Text>
    ) : (
      <Text style={styles.textMedium}>{'-'}</Text>
    )}
  </View>
);

export default AdditionalRemarks;
